import { routerBack } from '@/src/common/utils/routerBack'
import {
  useCardManagementStackScreensAreModals,
  useCardStackScreen,
} from '@/src/app/main/(tabs)/card/card-management/_common/cardStackScreen'
import { router } from 'expo-router'

type CardStackScreenProps = Parameters<typeof useCardStackScreen>[0]

export function usePaymentScreen(
  name: CardStackScreenProps['name'],
  title: CardStackScreenProps['options']['title'],
  back: boolean | Parameters<typeof router.dismissTo>[0] = true,
) {
  const cardManagementStackScreensAreModals = useCardManagementStackScreensAreModals()
  return useCardStackScreen({
    name,
    options: {
      title,
      ...(cardManagementStackScreensAreModals ? { presentation: 'transparentModal' } : undefined),
    },
    sectionProps: back
      ? {
          onBackPress() {
            typeof back === 'string' ? router.dismissTo(back) : void routerBack()
          },
        }
      : undefined,
  })
}
